export const fetcher = (url: string, token?: string) =>
  fetch(url, {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  }).then(res => res.json());

export async function postRequest(url: string, { arg }: { arg: any }) {
  const { token, ...data } = arg;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json();

    throw new Error(errorData.data.message || 'An error occurred');
  }

  return response.json();
}

export async function uploadRequest(
  url: string,
  data: FormData,
  token?: string,
) {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: data,
  });

  if (!response.ok) {
    const errorData = await response.json();

    throw new Error(errorData.data.message || 'An error occurred');
  }

  return response.json();
}

export async function putRequest(url: string, { arg }: { arg: any }) {
  const { token, ...data } = arg;

  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json();

    throw new Error(errorData.data.message || 'An error occurred');
  }

  return response.json();
}
